import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../utils/OggettiUtili";
import TabelleMonitoraggio from "./TabelleMonitoraggio";
import {states} from '../Wizard/States/States';

class InvioSchedeSpeciali extends Component {

    state = {
        filtri: {
            malattia: "",
            utenteInserimento: "",
            inserimentoFile: "",
            statoInvioScheda: "",
            dataDa: "",
            dataA: ""
        },
        malattie: JSON.parse(sessionStorage.getItem("malattie")),
    }

    rowsFiltriInvio = [
        {
            malattia: {
                id: "malattia",
                text: "malattia",
                tipo: "autocomplete",
                field: "malattia",
                numeroCol: 1,
                suggestions: this.state.malattie,
                keyField: "codice",
                descriptionField: "codDesc",
                suggestionField: "descrizione"
            },
            inserimentoFile: {
                id: "inserimentoFile", text: "", tipo: "select", field: "inserimentoFile", numeroCol: 2,
                suggestions: OggettiUtili.statoCaricamentoPdfSchedaSpeciale, defaultSelect: "--Stato di inserimento--"
            },
            dataDa: {
                id: "dataDa",
                text: "dataDa",
                tipo: "data",
                field: "dataDa",
                placeholder: "data segnalazione da",
                numeroCol: 3
            }
        },
        {
            utenteInserimento: {
                id: "utenteInserimento",
                text: "Utente inserimento",
                tipo: "input",
                field: "utenteInserimento",
                numeroCol: 1
            },
            statoInvioScheda: {
                id: "statoInvioScheda", text: "", tipo: "select", field: "statoInvioScheda", numeroCol: 2,
                suggestions: OggettiUtili.statoInvioPdfSchedaSpeciale, defaultSelect: "--Stato Invio--"
            },
            dataA: {
                id: "dataA",
                text: "dataA",
                tipo: "data",
                field: "dataA",
                placeholder: "data segnalazione a",
                numeroCol: 3
            }
        }
    ]

    colsTabInvioSchede = [
        {
            key: "malattia", name: "Malattia", sortDirection: "none", tipo: "dizionario",
            oggetto: JSON.parse(sessionStorage.getItem("malattiePerCodice")), campo: "descrizione"
        },
        {
            key: "idSegnalazione",
            name: "ID Segnalazione",
            sortDirection: "none",
            tipo: "link",
            path: "/wizardSegnalazione",
            nomeParametro: "idSegnalazione",
            state: {currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI}
        },
        {key: "utenteInserimento", name: "Utente Inserimento", sortDirection: "none"},
        {key: "nome", name: "Nome Paziente", sortDirection: "none"},
        {key: "cognome", name: "Cognome Paziente", sortDirection: "none"},
        {key: "dataSegnalazione", name: "Data segnalazione", sortDirection: "none", tipo: "data"},
        {
            key: "pdfAssociato",
            name: "Stato di Inserimento",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.statoCaricamentoPdfSchedaSpeciale
        },
        {
            key: "pdfInviato",
            name: "Stato di Invio",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.statoInvioPdfSchedaSpeciale,
            notShown: {field: "malattia", conditionValue: "0413"}
        },
        {
            key: "prosegui", tipo: "link", label: "Prosegui", path: "/wizardSegnalazione",
            nomeParametro: "idSegnalazione", state: {schedaSpeciale: true}
        },
   ]

    sendFiltri(filtriInvio) {
        this.props.creaFiltri({filtri: filtriInvio})
    }

    setStateGenerico(object) {
        this.setState(object)
    }

    constructor(props) {
        super(props);
        this.setStateGenerico = this.setStateGenerico.bind(this)
        this.sendFiltri = this.sendFiltri.bind(this)

    }

    render() {

        return (
            <div>
                <TabelleMonitoraggio
                    cols={this.colsTabInvioSchede}
                    title={"Stato PDF schede speciali"}
                    emptyMsg={"Non ci sono segnalazioni"}
                    lengthEditable={true}
                    homePage={true}
                    information={["03", "04", "06"]}
                    rowFiltri={this.rowsFiltriInvio}
                    filtri={this.state.filtri}
                    sendFiltri={this.sendFiltri}
                    invioSchedaSpeciale={"1"}
                    ruolo={"r"}
                    setStateGenerico={this.setStateGenerico}
                />
            </div>
        )
    }


}

export default withTranslation('common')(InvioSchedeSpeciali);

